'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const counters = {};
const uniqueId = (prefix) => {
  counters[prefix] = (counters[prefix] || 0) + 1;
  return `${prefix}${counters[prefix]}`;
};

exports.uniqueId = uniqueId;
//# sourceMappingURL=uniqueId.cjs.js.map
